export type PartnerLogo = {
    src: string;
    alt: string;
    /**
     * Доля размера карточки (object-fit: contain).
     * 1 = максимально крупно с padding, меньше = визуально легче.
     */
    scale?: number;
    /** light — белая; dark — тёмная; red — красная (Альфа-Банк) */
    card?: "light" | "dark" | "red";
    /** Крупнее карточка (ключевой партнёр) */
    featured?: boolean;
};

/** Логотипы из public/images/partners — каждый подогнан под читаемость */
export const PARTNER_LOGOS: PartnerLogo[] = [
    { src: "/images/partners/client-logo-1.png", alt: "Альфа Банк", scale: 1, card: "red", featured: true },
    { src: "/images/partners/client-logo-4.png", alt: "Free-Broker", scale: 0.62 },
    { src: "/images/partners/client-logo-6.png", alt: "Biznes.Mova", scale: 0.88 },
    { src: "/images/partners/client-logo-7.png", alt: "levsha", scale: 0.82 },
    { src: "/images/partners/client-logo-8.png", alt: "Everis Service", scale: 0.8 },
    { src: "/images/partners/client-logo-9.png", alt: "Metacommerce offline", scale: 0.86 },
    { src: "/images/partners/client-logo-10.png", alt: "MVK", scale: 0.88 },
    { src: "/images/partners/client-logo-11.png", alt: "FOR BEAUTY", scale: 0.58 },
    { src: "/images/partners/client-logo-12.png", alt: "Пищёвка 3D", scale: 0.86 },
    { src: "/images/partners/metal-group.png", alt: "METAL Group", scale: 0.9 },
    { src: "/images/partners/okonnaya-sluzhba.png", alt: "Оконная служба+", scale: 0.86 },
    { src: "/images/partners/dahon-pavel.png", alt: "Dahon Pavel Lounge", scale: 0.92 },
];
